







import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class App extends Vue {
  get onMobile() {
    if (!this.$store.state.onMobile) return "";
    return "on-mobile h-100";
  }
}
